import { toJS } from 'mobx';
import moment from 'moment';

export function getIn(obj, path, defval) {
  if (!obj) return;
  let node = obj;
  for (let pp of path) {
    if (node === undefined || node === null) {
      return defval;
    }
    node = node[pp];
    if (node === undefined || node === null) {
      return defval;
    }
  }
  return node;
}

export function delay(ms, canceller) {
  let timeoutHandle;
  return new Promise((resolve, reject) => {
    let unsubscribe;
    if (canceller) {
      unsubscribe = canceller.subscribe(() => {
        if (timeoutHandle) {
          clearTimeout(timeoutHandle);
          timeoutHandle = undefined;
        }
        unsubscribe();
        reject('$CANCEL');
      })
    }
    timeoutHandle = setTimeout(() => {
      resolve();
      timeoutHandle = undefined;
      if (unsubscribe) unsubscribe();
    }, ms);
  });
}

export function selfGuard() {
  let inProgress = false;
  return {
    inProgress: () => inProgress,
    update: (fcn) => {
      try {
        inProgress = true;
        fcn();
      }
      finally {
        inProgress = false;
      }
    }
  }
}

export function noUndef(obj) {
  for (let k in obj) {
    if (obj[k] === undefined) {
      return false;
    }
  }
  return true;
}

export function noDiff(l, r) {
  for (let k in l) {
    if (l[k] !== r[k]) return false;
  }
  for (let k in r) {
    if (l[k] !== r[k]) return false;
  }
  return true;
}

export function areEqualShallow(a, b) {
  for (var key in a) {
    if (!(key in b) || a[key] !== b[key]) {
      return false;
    }
  }
  for (var key in b) {
    if (!(key in a) || a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}

export function genGuid() { // Public Domain/MIT
  var d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}


let uid = 0;
export function genUid() {
  return uid++;
}

export function materializeValues(values) {
  let result = {};
  for (let k in values) {
    result[k] = values[k];
  }
  return result;
}

export function roundTime(tOrig, timeAtomSec) {
  const secFromDayStart = moment(tOrig).diff(moment(tOrig).startOf('day'), 'seconds');
  const atomPart = secFromDayStart / timeAtomSec;
  let newSecsFromDayStart = Math.round(atomPart) * timeAtomSec;
  let tNew = moment(tOrig).startOf('day').add({ seconds: newSecsFromDayStart });
  let result;
  if (timeAtomSec >= 24 * 60 * 60) {
    result = tNew.format('YYYY-MM-DD');
  } else {
    result = tNew.toISOString();
  }
  return result;
}

export function ceilTime(tOrig, timeAtomSec, isNightGranularity) {
  const secFromDayStart = moment(tOrig).diff(moment(tOrig).startOf('day'), 'seconds');
  const atomPart = secFromDayStart / timeAtomSec;
  let newSecsFromDayStart = Math.ceil(atomPart) * timeAtomSec;
  if (isNightGranularity && newSecsFromDayStart === timeAtomSec) {
    newSecsFromDayStart /= 2;
  }
  let tNew = moment(tOrig).startOf('day').add({ seconds: newSecsFromDayStart });
  if (timeAtomSec >= 24 * 60 * 60) {
    return tNew.format('YYYY-MM-DD');
  } else {
    return tNew.toISOString();
  }
}

export function floorTime(tOrig, timeAtomSec, isNightGranularity) {
  const secFromDayStart = moment(tOrig).diff(moment(tOrig).startOf('day'), 'seconds');
  const atomPart = secFromDayStart / timeAtomSec;
  let newSecsFromDayStart = Math.floor(atomPart) * timeAtomSec;
  if (isNightGranularity && newSecsFromDayStart === timeAtomSec) {
    newSecsFromDayStart /= 2;
  }
  let tNew = moment(tOrig).startOf('day').add({ seconds: newSecsFromDayStart });
  if (timeAtomSec >= 24 * 60 * 60) {
    return tNew.format('YYYY-MM-DD');
  } else {
    return tNew.toISOString();
  }
}

// export function ceilTime(tOrig, timeAtomSec) {
//   const dayGranularityOrMore = (timeAtomSec >= 24 * 60 * 60);
//   const twelveHours = 12 * 60 * 60;
//   const secFromDayStart = moment(tOrig).diff(moment(tOrig).startOf('day'), 'seconds');
//   const atomPart = secFromDayStart / timeAtomSec;
//   let newSecsFromDayStart = Math.ceil(atomPart) * timeAtomSec;
//   let seconds = (dayGranularityOrMore && atomPart < .5) ? twelveHours : newSecsFromDayStart;
//   let tNew = moment(tOrig).startOf('day').add({ seconds });
//   if (dayGranularityOrMore) {
//     return tNew.format('YYYY-MM-DD');
//   } else {
//     return tNew.toISOString();
//   }
// }

// export function floorTime(tOrig, timeAtomSec) {
//   const dayGranularityOrMore = (timeAtomSec >= 24 * 60 * 60);
//   const twelveHours = 12 * 60 * 60;
//   const secFromDayStart = moment(tOrig).diff(moment(tOrig).startOf('day'), 'seconds');
//   const atomPart = secFromDayStart / timeAtomSec;
//   let newSecsFromDayStart = Math.floor(atomPart) * timeAtomSec;
//   let seconds = (dayGranularityOrMore && atomPart < .5) ? twelveHours : newSecsFromDayStart;
//   let tNew = moment(tOrig).startOf('day').add({ seconds });
//   if (dayGranularityOrMore) {
//     return tNew.format('YYYY-MM-DD');
//   } else {
//     return tNew.toISOString();
//   }
// }

export function expandIntervalEnd({ start, end }, minLengthSecs) {
  let oldStart = moment(start);
  let oldEnd = moment(end);

  if (oldEnd.diff(oldStart, 'second') < minLengthSecs) {
    return {
      start: oldStart.toISOString(),
      end: oldStart.add({ seconds: minLengthSecs }).toISOString(),
    }
  } else {
    return {
      start,
      end,
    }
  }
}

export function shiftIntervalAfter({ start, end }, base) {
  let tDiff = moment(start).diff(moment(base), 'seconds');

  if (tDiff > 0) {
    return {
      start: moment(start).add({ seconds: tDiff }).toISOString(),
      end: moment(end).add({ seconds: tDiff }).toISOString(),
    }
  } else {
    return {
      start: moment(start).toISOString(),
      end: moment(end).toISOString(),
    }
  }
}


export function channel() {
  return {
    id: 0,
    subscribers: {},
    subscribe(listener) {
      let id = this.id++;
      this.subscribers[id] = listener;
      return () => {
        delete this.subscribers[id];
      }
    },
    trigger(...args) {
      for (let sub of Object.values(this.subscribers)) {
        sub(...args);
      }
    }
  }
}


export function distinct(arr, fcn) {
  let result = [];
  for (let o of arr) {
    if (result.findIndex(ro => fcn(ro) === fcn(o)) === -1) {
      result.push(o);
    }
  }
  return result;
}

export function replaceBetween(str, start, end, replacementString) {
  return str.substring(0, start) + replacementString + str.substring(end);
}

export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}


// WEBPACK FOOTER //
// ./src/utils/index.js